import HeaderPage from "../../components/lines-managements/header/HeaderPage";
import AffiliatesList from "../../components/affiliates";
import useCan from "../../components/users/permissions/useCan";

const statusFilterOptions = [
  { label: "Ne pritje", id: 0 },
  { label: "Aprovuar", id: 1 },
  { label: "Refuzuar", id: 2 },
  { label: "Pezulluar", id: 3 }
];

const Affiliates: React.FC = () => {
  const can = useCan("affiliates.affiliate.create");
  return (
    <>
      <HeaderPage
        {...(can && {
          link: {
            to: "add",
            children: "Shto partner te ri",
            state: ["Partneret affiliate", "Shto partner te ri"]
          }
        })}
        hasFilter
        filterName="Statusi"
        filterSelctor="status"
        options={statusFilterOptions}
      />
      <AffiliatesList />
    </>
  );
};

export default Affiliates;
